import type { PQueryBuilderConstraints } from '@pushly/aqe/lib/components/pquery-builder/types'

/**
 * The structural rules every query a journey carries is authored under.
 *
 * One definition rather than one per builder: a journey's entry criteria and its event filter sit
 * on the same screen, so a rule applied to one and not the other reads as two different editors
 * for what is plainly the same kind of query.
 *
 * Group descriptions are off because nothing downstream reads one. Turning them off hides the
 * editor only — a description already stored on a group is kept and still serialized, so an
 * existing journey is not rewritten by opening it.
 */
export const JOURNEY_QUERY_CONSTRAINTS: PQueryBuilderConstraints = {
    allowGroupDescriptions: false,
}
